export const publicProfileSchema = {
  tabs: [
    { key: 'company', label: 'Company Details' },
    { key: 'marquee', label: 'Marquee' },
    { key: 'qr', label: 'Business QR' },
    { key: 'payment', label: 'Payment Settings' },
  ],
  schemas: {
    company: {
      fields: [
        { name: 'companyName', label: 'Company Name', type: 'text', required: true },
        { type: 'group', name: 'phoneGroup', children: [
            { name: 'phonePrefix', type: 'select', placeholder: 'US +1', required: true, options: [
                { label: 'US +1', value: '+1' },
                { label: 'UK +44', value: '+44' },
                { label: 'IN +91', value: '+91' },
              ]
            },
            { name: 'phone', type: 'tel', placeholder: 'Enter phone', required: true }
          ]
        },
        { name: 'fax', label: 'Fax', type: 'text', placeholder: 'Enter fax' },
        { name: 'address', label: 'Address', type: 'textarea', placeholder: 'Enter address' },
        { name: 'thumbnail', label: 'Thumbnail', type: 'file' },
      ],
      buttons: [
        { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
        { label: 'Submit', action: 'submit', type: 'button', className: 'btn-next' }
      ]
    },
    marquee: {
      fields: [
        { type: 'group', name: 'row1', children: [
            { name: 'message1', label: 'Message 1', type: 'textarea', placeholder: 'Enter marquee message', required: true },
            { name: 'message2', label: 'Message 2', type: 'textarea', placeholder: 'Enter marquee message' }
          ]
        },
        { type: 'group', name: 'row2', children: [
            { name: 'message3', label: 'Message 3', type: 'textarea', placeholder: 'Enter marquee message' },
            { name: 'message4', label: 'Message 4', type: 'textarea', placeholder: 'Enter marquee message' }
          ]
        }
      ],
      buttons: [
        { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
        { label: 'Submit', action: 'submit', type: 'button', className: 'btn-next' }
      ]
    },
    qr: {
      fields: [
        { type: 'group', name: 'row1', children: [
            { name: 'paymentUrl', label: 'Payment URL', type: 'text', placeholder: 'Enter payment URL', required: true },
            { name: 'qrImage', label: 'Upload QR Code', type: 'file' }
          ]
        }
      ],
      buttons: [
        { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
        { label: 'Submit', action: 'submit', type: 'button', className: 'btn-next' }
      ]
    },
    payment: {
      fields: [
        {
          type: 'group_radio',
          name: 'cardPayments',
          label: 'Card Payments',
          children: [
            { name: 'creditCard', label: 'Credit Card', type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'enable' },
            { name: 'emv',        label: 'EMV',         type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'disable' },
            { name: 'magStripe',  label: 'MagStripe',   type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'enable' },
          ]
        },
        {
          type: 'group_radio',
          name: 'digitalWallets',
          label: 'Digital Wallets',
          children: [
            { name: 'applePay',  label: 'Apple Pay',   type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'enable' },
            { name: 'googlePay', label: 'Google Pay',  type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'disable' },
          ]
        },
        {
          type: 'group_radio',
          name: 'bankOthers',
          label: 'Bank Based & Others',
          children: [
            { name: 'aidPay',    label: 'AID Pay',     type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'enable' },
            { name: 'cash',      label: 'Cash',        type: 'radio', options: [
                { label: 'Enable', value: 'enable' },
                { label: 'Disable', value: 'disable' }
              ], defaultValue: 'disable' },
          ]
        },
      ],
      buttons: [
        { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
        { label: 'Submit', action: 'submit', type: 'button', className: 'btn-next' }
      ]
    }
  }
};